import { GenericResponse } from "./genericResponse.model";
import { User } from "./user.model";

export class mediaImages {
    MediaId: number;
    InventionId: string;
    FileName: string;
    Media: string;
    FileExtension: string;
}

export class mediaDoc {
    MediaId: number;
    InventionId: string;
    DocumentTypeID: string;
    FileName: string;
    Media: string;
    FileExtension: string;
}

export class roiRefreshFlag {
    inventionId: number;
    isRefreshDoc: boolean;
    isRefreshImage: boolean;
    dtUpdated: Date;
}

export interface MediaImagesResponse extends GenericResponse {
    listImages: mediaImages[];
    currentUser: User;
    lastAdded: number;
}

export interface MediaDocImagesResponse extends GenericResponse {
    listDocImages: mediaDoc[];
    currentUser: User;
    lastAdded: number;
}

export interface ROIRefreshFlagResponse extends GenericResponse {
    currentUser: User;
    roiRefreshFlag: roiRefreshFlag;
}
